import { EnumUserTypes, RecruiterApprovalStatus } from "@utils/constants";

export function getPostLoginRoute(user: any): string {
    if (!user) return "/login";

    const isRecruiter = user.userType === EnumUserTypes.RECRUITER;
    const isCandidate = user.userType === EnumUserTypes.CANDIDATE;
    const isReferrealAmbassador =
        user.userType === EnumUserTypes.REFERRAL_AMBASSADOR;
    const isHiringCompany =
        user.userType === EnumUserTypes.HIRING_COMPANY;

    // Username missing (highest priority)
    if (!user.userName) {
        return "/generate-user-name";
    }

    // Recruiter approval pending
    if (
        isRecruiter &&
        (!user.recruiterApprovalStatus ||
            user.recruiterApprovalStatus === RecruiterApprovalStatus.REQUESTED)
    ) {
        return "/create-profile";
    }

    // Candidate default profile flow
    if (isCandidate && user.enableDefaultProfileOption) {
        return "/create-profile";
    }

    // Standard dashboards
    if (isCandidate || isRecruiter || isReferrealAmbassador) {
        return "/dashboard";
    }

    // Hiring company
    if (isHiringCompany) {
        return "/requirements";
    }

    // Fallback
    return "/";
}
